<div class="bg" *ngIf="quickStockNotification$ | async as quickStockNotification">
  <form class="gonvarri-quick-stock-notification" (submit)="onSubmitForm()">
    <section class="gonvarri-quick-stock-notification__header">
      <div class="gonvarri-quick-stock-notification__header__close">
        <span (click)="closeModal()">
          <cx-icon [type]="ICON_TYPE.CLOSE" />
        </span>
      </div>
      <div class="gonvarri-quick-stock-notification__header__title">
        <h1>
          {{ 'quickstock.notification.title' | cxTranslate }}
        </h1>
      </div>
    </section>
    <section
      class="gonvarri-quick-stock-notification__body"
      *ngIf="!!!quickStockNotification.removeUrl"
    >
      <div class="gonvarri-quick-stock-notification__body__texts">
        <strong class="gonvarri-quick-stock-notification__body__texts__alert">
          {{ 'quickstock.notification.alert' | cxTranslate }}
        </strong>
        <p class="gonvarri-quick-stock-notification__body__texts__explanation">
          {{ 'quickstock.notification.explanation' | cxTranslate }}
        </p>
      </div>
      <div>
        {{ 'quickstock.notification.selectnotifications' | cxTranslate }}
      </div>
      <div
        *ngFor="let channel of quickStockNotification.stockNotificationForm.channels"
        [ngClass]="channel.visible ? 'gonvarri-quick-stock-notification__body__agree' : 'display-none'"
      >
        <span
          class="gonvarri-quick-stock-notification__body__agree__label"
          *ngIf="channel.visible"
        >
          {{ 'quickstock.notification.email' | cxTranslate }}
        </span>
        <input
          type="checkbox"
          name="gonvarri-quick-stock-notification__body__agree__checkbox"
          class="gonvarri-quick-stock-notification__body__agree__checkbox"
          [(ngModel)]="receiveOnEmail"
          *ngIf="channel.visible"
          [value]="channel.value"
          [checked]="channel.enabled"
        />
      </div>
    </section>
    <section
      class="gonvarri-quick-stock-notification__body"
      *ngIf="!!quickStockNotification.removeUrl"
    >
      <p>
        {{ 'quickstock.notification.alertunsubscribe' | cxTranslate }}
      </p>
    </section>
    <section class="gonvarri-quick-stock-notification__footer">
      <button
        type="button"
        class="gonvarri-quick-stock-notification__footer__cancel"
        (click)="closeModal()"
      >
        {{ 'quickstock.notification.cancel' | cxTranslate }}
      </button>
      <button
        type="submit"
        class="gonvarri-quick-stock-notification__footer__subscribe"
        [disabled]="!receiveOnEmail"
        *ngIf="!!!quickStockNotification.removeUrl"
      >
        {{ 'quickstock.notification.subscribe' | cxTranslate }}
      </button>
      <button
        type="submit"
        class="gonvarri-quick-stock-notification__footer__unsubscribe"
        *ngIf="!!quickStockNotification.removeUrl"
      >
        {{ 'quickstock.notification.unsubscribe' | cxTranslate }}
      </button>
    </section>
  </form>
</div>
